import { IPosition } from "@portal/types/api/IPosition";
import { getInfrontSDKSnapshot, subscribeInfrontSDK } from "./infrontSDK";
import { IOrder } from "@portal/types/api/IOrder";
import { subscriber } from "./subscriber";
import { subscribeToFeed } from "./subscribeToFeed";
import { IAlarm } from "@portal/types/api/IAlarm";

const RETRY_ATTEMPTS = 3;
const RETRY_DELAY_MS = 500;

const runWhenInfrontSDKIsReady = (callback: () => void, attempt = 0) => {
  const snapshot = getInfrontSDKSnapshot();
  if (snapshot.instance && snapshot.isReady) {
    callback();
    return;
  }

  if (attempt < RETRY_ATTEMPTS) {
    setTimeout(() => runWhenInfrontSDKIsReady(callback, attempt + 1), RETRY_DELAY_MS);
    return;
  }

  const unsubscribe = subscribeInfrontSDK(() => {
    const nextSnapshot = getInfrontSDKSnapshot();
    if (nextSnapshot.instance && nextSnapshot.isReady) {
      unsubscribe();
      callback();
    }
  });
};

export const registerStockObserverForOrder = async (order: IOrder) => {
  runWhenInfrontSDKIsReady(() => {
    if (order.tickerCode) {
      subscriber(18177, order.tickerCode);
    }
  });
};

export const registerStockObserverForPositions = async (positions: IPosition[]) => {
  runWhenInfrontSDKIsReady(() => {
    positions.forEach(p => {
      if (p.tickerCode && p.instrumentType === "00") {
        subscriber(18177, p.tickerCode);
      } else if (p.tickerCode && (p.instrumentType === "01" || p.instrumentType === "02" || p.instrumentType === "22")) {
        subscriber(18199, p.tickerCode);
      }
    });
  });
};

export const registerStockObserverForAlarms = async (alarms: IAlarm[] | undefined) => {
  runWhenInfrontSDKIsReady(() => {
    if (alarms === undefined) return;
    alarms.forEach(alarm => {
      if (alarm.ticker) {
        subscriber(alarm.infrontFeedId ?? 18177, alarm.ticker);
      }
    });
  });
};

export const registerStockObserverForVisitedStock = async (feedId: number, ticker: string) => {
  runWhenInfrontSDKIsReady(() => {
    if (ticker && (feedId === 18177 || feedId === 18199)) {
      subscriber(feedId, ticker);
    }
  });
};

export const registerStockObserverForOsloBors = async () => {
  runWhenInfrontSDKIsReady(() => {
    subscribeToFeed(18177);
    subscribeToFeed(18199);
  });
};
